import { StyleProp, View, ViewStyle } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import { StartPreparationStatus } from 'store/Orders/types';
import Text from 'components/Text';

import { OrderStartPreparationStatusInterfaces } from './constants';
import { styles } from './styles';

type OrderStartPreparationStatusBadgeProps = {
  status?: StartPreparationStatus;
  style?: StyleProp<ViewStyle>;
  iconSize?: number;
  textSize?: number;
};

export const OrderStartPreparationStatusBadge = ({
  status,
  style,
  iconSize = 16,
  textSize = 10,
}: OrderStartPreparationStatusBadgeProps) => {
  const statusInterface =
    status && OrderStartPreparationStatusInterfaces[status];

  if (!status || !statusInterface) return null;

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: statusInterface.color,
          paddingBottom: 3,
        },
        style,
      ]}
    >
      <View style={styles.content}>
        <MaterialCommunityIcons
          name={statusInterface.iconName}
          size={iconSize}
          color="white"
        />
      </View>
      <View style={styles.content}>
        <Text
          color="white"
          font="bold"
          size={textSize}
          style={styles.label}
          id={statusInterface.translationKey}
        />
      </View>
    </View>
  );
};
